import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from '.';
import { useSelector } from 'react-redux';

const selectSlice = (state: RootState) => state.local || initialState;

export const selectLocal = createSelector([selectSlice], state => state);

export const useLocalSelector = () => useSelector(selectLocal);
